import React from 'react';
export function TomosSection() {
  const tomos = [{
    icon: '📘',
    title: 'Tomo 1 — Fundamentos Pro',
    subtitle: '"De Cero a Tu Primer Servicio Profesional"',
    items: ['Sistema de 3 baldes que elimina el 90% de las microrrayas durante el lavado.', 'Descontaminación química paso a paso.', 'Clay bar sin dañar la pintura.', 'Protocolo de secado sin rayas.', 'Los 12 errores que arruinan un auto antes de empezar.', 'Checklist para tu primer servicio pago.']
  }, {
    icon: '📗',
    title: 'Tomo 2 — El Arte Del Pulido',
    subtitle: '"Corrección De Pintura: El Servicio Que Cambia Tu Negocio"',
    items: ['Cómo funciona la pintura de un auto.', 'Swirl marks, hologramas y rayas profundas.', 'Pulidoras orbitales vs rotativas.', 'Corrección en 1, 2 y 3 pasos.', 'El servicio que cobra $150.000 o más.']
  }, {
    icon: '📙',
    title: 'Tomo 3 — Interiores Extremos',
    subtitle: '"Limpieza Profunda y Restauración"',
    items: ['Extracción de tapizados.', 'Restauración de plásticos y cueros.', 'Eliminación de olores definitiva.', 'El servicio que fideliza de por vida.']
  }, {
    icon: '📕',
    title: 'Tomo 4 — Química y Costos',
    subtitle: '"El Sistema Para Ganar Más Sin Trabajar Más"',
    items: ['Diluciones correctas por producto.', 'Costo real por servicio.', 'Margen neto de cada trabajo.', 'Cómo comprar bien y gastar menos.']
  }, {
    icon: '📒',
    title: 'Tomo 5 — El Negocio Cash',
    subtitle: '"Clientes, Agenda Llena y Cobrar Lo Que Corresponde"',
    items: ['Primeros clientes sin redes ni publicidad.', 'Cómo fijar precios sin miedo.', 'Agenda llena en 30 días.', 'Cómo cobrar siempre en el momento.']
  }, {
    icon: '📓',
    title: 'Tomo 6 — Protección y Sellado',
    subtitle: '"El Servicio De Mayor Ticket y Máxima Fidelización"',
    items: ['Ceras, selladores y cerámicos.', 'Aplicación de protección cerámica paso a paso.', 'El servicio que cobra $150.000 a $400.000.', 'Fidelización de clientes de por vida.']
  }];
  return <section className="py-16 px-4 bg-gray-900 text-white" data-id="element-267">
      <div className="max-w-6xl mx-auto" data-id="element-268">
        <h2 className="text-3xl md:text-5xl font-black text-center mb-12 text-yellow-500 uppercase tracking-wide" data-id="element-269">
          📘 LOS 6 TOMOS DEL MEGAPACK
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-5" data-id="element-270">
          {tomos.map((tomo, index) => <div key={index} className="bg-gray-800 rounded-xl md:rounded-2xl border border-gray-700 overflow-hidden shadow-xl flex flex-col" data-id="element-271">
              <div className="bg-gray-750 p-2.5 md:p-4 border-b border-gray-700" data-id="element-272">
                <h3 className="text-xs md:text-lg font-bold flex items-center gap-1.5 md:gap-2 text-white mb-0.5 md:mb-1" data-id="element-273">
                  <span data-id="element-274">{tomo.icon}</span> {tomo.title}
                </h3>
                <p className="text-yellow-500 font-medium text-[10px] md:text-sm italic leading-tight" data-id="element-275">
                  {tomo.subtitle}
                </p>
              </div>
              <div className="p-2.5 md:p-4 flex flex-col flex-1" data-id="element-276">
                <ul className="space-y-1 md:space-y-2 mb-3 md:mb-4 flex-1" data-id="element-277">
                  {tomo.items.map((item, i) => <li key={i} className="flex items-start gap-1.5 md:gap-2 text-gray-300 text-[10px] md:text-sm" data-id="element-278">
                      <span className="text-green-500 mt-0.5" data-id="element-279">✔</span>
                      <span data-id="element-280">{item}</span>
                    </li>)}
                </ul>
                <div className="bg-gray-900 inline-block px-2 py-1 md:px-4 md:py-1.5 rounded-lg border border-gray-700" data-id="element-281">
                  <span className="text-gray-400 font-bold mr-1 md:mr-2 text-[10px] md:text-sm" data-id="element-282">
                    VALOR:
                  </span>
                  <span className="text-white font-black line-through opacity-50 text-[10px] md:text-sm" data-id="element-283">
                    $5.000
                  </span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}